<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="契約編號"
          v-model="search.number"
          @keyup.enter="getOld18Logs(1)" />
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getOld18Logs(1)">搜尋</b-button>
        </div>
      </div>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getOld18Logs"
    >
      <template #cell(created_at)="row">
        {{ convertRocDate(row.item.created_at) }}
      </template>
    </tables-page>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import oldSystemApi from "@/models/API/oldSystemApi";
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'oldSystemContractPayNoticeAddressLog',
  components: {
    BreadCrumb,
    TablesPage,
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '舊系統-操作日誌', url: '', isActive: true },
          { name: '契約繳費通知地址LOG', url: '', isActive: false }
        ]
      },
      search: {
        number: ''
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "plan",
            label: "組別",
          },
          {
            key: "status",
            label: "權益",
          },
          {
            key: "number",
            label: "契約編號",
          },
          {
            key: "member_name",
            label: "姓名",
          },
          {
            key: "join_date",
            label: "入會日期",
          },
          {
            key: "Baddress",
            label: "指定地址",
          },
          {
            key: "Haddress_1",
            label: "戶籍地址",
          },
          {
            key: "pay_name",
            label: "要助人",
          },
          {
            key: "cellphone",
            label: "手機",
          },
          {
            key: "Caddress",
            label: "通訊地址",
          },
          {
            key: "receive",
            label: "帳單領取",
          },
          {
            key: "payment_source",
            label: "繳費方式",
          },
          {
            key: "beneficiary_ID_number",
            label: "受款人身分證",
          },
          {
            key: "created_at",
            label: "異動時間",
          },
          {
            key: "command",
            label: "執行命令"
          },
        ],
        page: {},
      }
    }
  },
  mounted() {
    this.oldSystemApi = new oldSystemApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.oldSystemApi.page);
      this.getOld18Logs();
    },
    convertRocDate,
    // 查詢舊系統-查詢契約繳費通知地址LOG
    getOld18Logs(pageIndex = null) {
      const params = {
        ...this.search,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.oldSystemApi.getOld18Logs((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        number: '',
        remark: ''
      }

      this.getOld18Logs(1);
    }
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/oldSystemContractPayNoticeAddressLog.vue